import React from 'react';
import LogIn from 'stash/components/log-in/LogIn';

const LoginRoute = (props) => <LogIn {...props} />;

export default LoginRoute;
